import api from '../api';

let apiUrl = 'dashboard-banners';

const state = {
    data: {},
    meta: {}
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('set', response);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, response) {
        state.data = response.data;
    }
};

const getters = {
    all: (state) => {
        return state.data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
